import { ClearOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, InputNumber, Select, Table } from 'antd'
import { FC } from 'react'
import useFiltersForm from '../../../../hooks/forms/use-filters-form'
import { outputDateFormat } from '../../../../constants/constants'
import Roller from '../../../../components/form-items/roller/roller'
import { stampShapes } from '../../../../constants/entity-enums/stamp-shapes'
import MaterialGroups from '../../../../components/form-items/material-groups/material-groups'
import styled from 'styled-components'
import './filters-form.css'

const ActionsRow = styled(Table.Summary.Row)`
    & .actions-cell {
        position: sticky;
        z-index: 6;
        right: 12px;
        background: white;
    }

    .actions-cell:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: -1px;
        left: 0;
        width: 30px;
        transform: translateX(-100%);
        transition: box-shadow 0.3s;
    }
`

const shapeOptions = stampShapes.map(item => ({
    value: item,
}))

interface FiltersFormProps {}

const FiltersForm: FC<FiltersFormProps> = () => {
    const { form, onSearch, onClear } = useFiltersForm()

    return (
        <Form
            form={form}
            component={false}
            variant={'filled'}
            onFieldsChange={() => {
                onSearch()
            }}
        >
            <ActionsRow>
                <Table.Summary.Cell index={0}>
                    <Form.Item name={'name'} noStyle>
                        <InputNumber
                            style={{ width: '100%' }}
                            controls={false}
                            placeholder={'Номер'}
                        />
                    </Form.Item>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={1} />
                <Table.Summary.Cell index={2} />
                <Table.Summary.Cell index={3} />
                <Table.Summary.Cell index={3.5} />
                <Table.Summary.Cell index={4}>
                    <Roller rules={[]} noStyle />
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} />
                <Table.Summary.Cell index={7} />
                <Table.Summary.Cell index={8} />
                <Table.Summary.Cell index={9} />
                <Table.Summary.Cell index={10} />
                <Table.Summary.Cell index={11}>
                    <Form.Item name={'shape'} noStyle>
                        <Select
                            style={{ width: '100%' }}
                            placeholder={'Форма'}
                            options={shapeOptions}
                            mode={'multiple'}
                        />
                    </Form.Item>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={12}>
                    <MaterialGroups rules={[]} noStyle />
                </Table.Summary.Cell>
                <Table.Summary.Cell index={13} />
                <Table.Summary.Cell index={14}>
                    <Form.Item name={['externalId']} noStyle>
                        <InputNumber
                            style={{ width: '100%' }}
                            controls={false}
                            placeholder={'Номер'}
                        />
                    </Form.Item>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={15} />
                <Table.Summary.Cell index={16} />
                <Table.Summary.Cell index={17} />
                <Table.Summary.Cell index={18} />
                <Table.Summary.Cell index={19}>
                    <Form.Item name={'endDate'} noStyle>
                        <DatePicker placeholder={'Дата'} format={outputDateFormat} />
                    </Form.Item>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={20} />
                <Table.Summary.Cell index={21} />
                <Table.Summary.Cell index={22} />
                <Table.Summary.Cell index={23} />
                <Table.Summary.Cell className={'actions-cell'} index={23}>
                    <Button
                        size={'small'}
                        icon={<ClearOutlined />}
                        title={'Сбросить фильтры'}
                        onClick={onClear}
                    >
                        Сброс
                    </Button>
                </Table.Summary.Cell>
            </ActionsRow>
        </Form>
    )
}

export default FiltersForm
